import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <CarouselSection />
        <IndexSection />
        <ContactSection />
        <UpdatesSection />
        <CommentsSection />
        <FeaturesSection />
        <RankingSection />
        <MediaSection />
        <TopicsSection />
        <AboutSection />
        <FaqSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}